import { Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';

import { startWith, switchMap } from 'rxjs';

import { I18nService } from '@core/i18n-legacy';
import { RadioComponent } from '@core/user-interface-legacy';
import type { RadioGroupItem } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-boolean-field',
  templateUrl: './evaluation-boolean-field.component.html',
  styleUrls: ['./evaluation-boolean-field.component.less'],
  imports: [RadioComponent],
})
export class EvaluationBooleanFieldComponent {
  private readonly i18n = inject(I18nService);

  protected readonly items: RadioGroupItem[] = [
    { option: this.i18n.translate('app.interview.boolean.yes'), value: 'yes' },
    { option: this.i18n.translate('app.interview.boolean.no'), value: 'no' },
  ];

  public readonly control = input.required<FormControl<string | null>>();

  protected value = toSignal(
    toObservable(this.control).pipe(
      switchMap(control => control.valueChanges.pipe(startWith(control.value))),
    ),
    { initialValue: null },
  );

  protected select(value: string): void {
    const control = this.control();

    control.setValue(value);
    control.markAsDirty();
    control.markAsTouched();
  }
}
